<template>
  <div class="plugin-shell-page">
    <BicyclePlugins :key="'position'" default-vehicle-mode="single" />
  </div>
</template>

<script>
import BicyclePlugins from '@/views/bicycle/bicyclePlugins.vue'

export default {
  name: 'PositionName',
  components: { BicyclePlugins }
}
</script>

<style scoped>
.plugin-shell-page {
  width: 100%;
  height: calc(100vh - 78px);
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
